module.exports = __webpack_public_path__ + "media/images/lp-tpe-f5baa687d2d287bd255af3a78e1430df.png";